import {
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngxs/store';
import * as OrderListActions from '@app/store/screening/screening.actions';

import { MatColumnDef, MatTable } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';

import { IMainTable, IPagination } from '@app/shared/interfaces/mainTable.interface';

import { MatDialog } from '@angular/material/dialog';

import { ScrenningStepText, statusScrenningText } from '@app/ips/models/enum/status-screnning.enum';
import { statusTradeColor, statusTradeText } from '@app/ips/models/enum/status-trades.enum';

@Component({
  selector: 'app-main-table',
  templateUrl: './main-table.component.html',
  styleUrls: ['./main-table.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class MainTableComponent implements OnInit {
  @Input() resetColumnFormater = '';
  @Input() dataSource: IMainTable[];
  @Input() pagination: IPagination;
  @Input() displayColumns: string[];
  @Input() labelColumns: string[] = [];
  @Input() idTable = 'idTrade';
  @Input() idStatusTrade: number = undefined;
  @Input() idTrade: number | string = undefined;
  @Input() mainRoute = '';
  @Input() responsive: boolean = false;

  @Output() pageChangeAction? = new EventEmitter();
  @Output() exporteFile = new EventEmitter();
  @Output() tradeReprocess = new EventEmitter();
  @Output() getProductReturnLabelEvt = new EventEmitter();

  @ViewChild('exporter') exporter: ElementRef;

  pageEvent: PageEvent;
  setCountStatus: number;

  @ViewChild(MatTable, { static: true }) table: MatTable<IMainTable>;
  @ContentChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>;

  constructor(public dialog: MatDialog, private _store: Store, private _router: Router) {}

  ngOnInit() {
    setTimeout(() => {
      this.exporteFile.emit(this.exporter);
    }, 2000);
  }

  onPaginationChange(event: PageEvent) {
    if (this.pageChangeAction.observed) {
      const page = event.pageIndex + 1;
      const size = event.pageSize;

      this.pageChangeAction.emit({
        page,
        size,
      });
    }
  }

  getProductReturnLabel(idTrade) {
    this.getProductReturnLabelEvt.emit(idTrade);
  }

  openDetails(idTrade: string) {
    const payload: OrderListActions.ScreeningStateModel = { idTrade };

    this._store.dispatch(new OrderListActions.SetTrade(payload));
    this._router.navigate([this.mainRoute, 'pedidos', payload.idTrade]);
  }

  openDetailsPricing(id: string) {
    this._router.navigate([this.mainRoute, 'precificacao', id]);
  }

  onTradeReprocess(tradeInfos) {
    this.tradeReprocess.emit(
      tradeInfos.idTradeExternal ? tradeInfos.idTradeExternal : tradeInfos.idTrade
    );
  }

  setStylesStatus(status: any) {
    if (status.color) {
      return { 'font-weight': 'bold', 'background-color': status.color };
    }
    const style = { 'font-weight': 'bold' };
    const color = { 'background-color': statusTradeColor[status] };
    return { ...style, ...color };
  }

  getDescriptionStatusTrades(status: any) {
    if (status.description) {
      return status.description;
    }
    return statusTradeText[status] || '-';
  }

  getDescriptionStatusScrenning(status: string) {
    return ScrenningStepText[status] || '-';
  }

  trackByFn(index: number): number {
    return index;
  }

  get tableClasses() {
    return {
      'table-responsive': this.responsive
    };
  }
}
